import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ItfDatabase } from '../../../models/itf-database.model';
import { ItfPago } from '../../../models/itf-pago.model';
import { ItfDatabaseService } from '../../../services/itf-database.service';

@Component({
  selector: 'app-itf-payment-modal',
  templateUrl: './itf-payment-modal.component.html',
  styleUrls: ['./itf-payment-modal.component.css']
})
export class ItfPaymentModalComponent implements OnInit {
  @Input() itfRecord!: ItfDatabase;
  @Input() show: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() paymentRegistered = new EventEmitter<ItfPago>();

  newPayment: Partial<ItfPago> = {};
  isSaving: boolean = false;
  error: string | null = null;

  paymentMethods = [
    'EFECTIVO', 
    'TRANSFERENCIA', 
    'TARJETA', 
    'MERCADO PAGO', 
    'EFECTIVO - EUROS', 
    'TRANSFERENCIA - EUROS', 
    'OTRO'
  ];

  constructor(private itfDatabaseService: ItfDatabaseService) {}

  ngOnInit(): void {
    this.resetPaymentForm();
  }

  private resetPaymentForm(): void {
    const currentYear = new Date().getFullYear();
    this.newPayment = {
      anio: currentYear,
      fechaPago: new Date().toISOString().split('T')[0],
      monto: 20000.00,
      metodoPago: 'EFECTIVO',
      notas: ''
    };
  }

  onClose(): void {
    this.resetPaymentForm();
    this.error = null;
    this.close.emit();
  }

  registrarPago(): void {
    if (!this.itfRecord.id) {
      this.error = 'ID de registro ITF no válido';
      return;
    }

    if (!this.newPayment.monto || this.newPayment.monto <= 0) {
      this.error = 'El monto debe ser mayor a 0';
      return;
    }

    if (!this.newPayment.anio) {
      this.error = 'Debe especificar el año';
      return;
    }

    this.isSaving = true;
    this.error = null;

    this.itfDatabaseService.registrarPago(this.itfRecord.id, this.newPayment).subscribe(
      (pago: ItfPago) => {
        this.isSaving = false;
        this.paymentRegistered.emit(pago);
        this.resetPaymentForm();
        this.close.emit();
      },
      (err: any) => {
        this.error = err.error?.error || 'Error al registrar el pago';
        this.isSaving = false;
      }
    );
  }

  onOverlayClick(event: MouseEvent): void {
    // Close modal if clicking directly on overlay (not on modal content)
    if ((event.target as HTMLElement).classList.contains('payment-form-modal')) {
      this.onClose();
    }
  }
}